// extracted by mini-css-extract-plugin
export default {"content":"Menu-module__content__kR8Ag","menuArrow":"Menu-module__menuArrow__HSqFL","menu":"Menu-module__menu__qgATZ"};